module.exports = __webpack_public_path__ + "img/x9-mumbai.40329cad.png";